import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const AdsPrincipalDetailRBAC = {
  pageID: 'fdeee319af4a229e6d47d1ae70a9b02e',
  elementID: {
    ViewOnly: '4dcedec48ad57250c71946a11566c21f',
  },
} as const

export const useAdsPrincipalDetailRBAC = createUseRBAC(AdsPrincipalDetailRBAC.elementID)

export type UseAdsPrincipalDetailRBACType = ReturnType<typeof useAdsPrincipalDetailRBAC>
